export const Scene_Visible_Marker = 'VisibleMarker_';
export const Scene_Marker = 'Marker_';
export const SphereMaterial = 'SphereM';
export const CameraZoomMultiplier = 10;
export const GroupLabelWidth = 40;
